// Business constants — placeholder values, easily replaced later.
export const BUSINESS = {
  name: "Columbus Home Sauna Installation",
  tagline: "Sauna Installation & Assembly",
  phone: "1 (708) 557-6297",
  email: "easybreezydeliverycbus@gmail.com",
  serviceArea: "Columbus, Ohio & surrounding areas",
  hours: "Mon – Sat · 8:00 – 18:00",
  established: "Serving Central Ohio",
};

export const NAV_LINKS = [
  { label: "Services", href: "#services" },
  { label: "Process", href: "#process" },
  { label: "Portfolio", href: "#portfolio" },
  { label: "Featured", href: "#featured" },
  { label: "FAQ", href: "#faq" },
  { label: "Contact", href: "#contact" },
];
